import logo from './logo.svg';
import './App.css';
import 'antd/dist/antd.css';
import BelgeGrubuVeTuru from './components/BelgeGrubuVeTuru';
import MainRouter from './components/MainRouter';

function App() {
  return (
    <MainRouter/>
  );
}

export default App;
